import { render, staticRenderFns } from "./index.vue?vue&type=template&id=28a2580b&"
import script from "./index.vue?vue&type=script&lang=ts&setup=true&"
export * from "./index.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28a2580b')) {
      api.createRecord('28a2580b', component.options)
    } else {
      api.reload('28a2580b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=28a2580b&", function () {
      api.rerender('28a2580b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/info/document/index.vue"
export default component.exports